{
  "checkoutMethods": ["standard"],
  "expressCheckoutMethods": ["paypal", "google_pay", "apple_pay"],
  "xApi": {
    "clientId": "20430694",
    "cartUrl": "https://x-api.scalefast.com/customer/provider",
    "cartTokenKey": "sf-cart-token",
    "cartProviderKey": "sf-cart-provider",
    "xApiKey": "36QEdhO8XD4I9NdjpdbIH8IejcYs4xEg40vD8TPN"
  },
  "taxes": {
    "entity": "Scalefast Inc. (trading as ESW)",
    "transaction_type": "b2b",
    "tax_inclusive": true
  },
  "username": "architects@scalefast.com",
  "password": "a123456S_"
}
